import DefaultThumbnail from '@assets/media/no_info_thumbnail.png';
import { Image } from 'common/components/image';
import { TIME_BEFORE_BUFFER } from 'common/config/constants';
import variables from 'common/config/variables';
import { getLivePoint, getThumbnailUrl, getVodThumbnailUrl } from 'common/services/helpers';
import { getClassName } from 'common/utils';
import React, { useCallback, useEffect, useState } from 'react';
const { FAST_SEEK_OFFSET } = variables;

interface FastSeekStripeProps {
  visible?: boolean;
  timestamp: number;
  chanId: string;
  endTime?: number;
  vod?: boolean;
  firstEpgStart?: number;
}
export default function FastSeekStripe(props: FastSeekStripeProps) {
  const [items, setItems] = useState<({ src: string; primary?: boolean } | undefined)[]>([]);
  // Show 2 thumbnails before now and 2 after now
  useEffect(() => {
    if (!props.visible || props.timestamp < 0) {
      setItems([]);
      return;
    }
    const endTime = Math.floor(!props.endTime ? getLivePoint() : props.endTime);
    const firstEpgStart = props.firstEpgStart || 0;
    const before = Array.from({ length: 3 }, (_, index) => ({
      timestamp: props.timestamp - (2 - index) * FAST_SEEK_OFFSET,
      primary: false
    }));
    const now = [{ timestamp: props.timestamp, primary: true }];
    const after = Array.from({ length: 3 }, (_, index) => ({
      timestamp: props.timestamp + (index + 1) * FAST_SEEK_OFFSET,
      primary: false
    }));

    const _items = [...before, ...now, ...after].map(({ timestamp, primary }) => {
      if (props.vod) {
        return timestamp >= 0
          ? { src: getVodThumbnailUrl(props.chanId, timestamp), primary }
          : undefined;
      } else {
        return timestamp >= firstEpgStart && timestamp < endTime + TIME_BEFORE_BUFFER
          ? {
              src: getThumbnailUrl(props.chanId, false, timestamp),
              primary
            }
          : undefined;
      }
    });

    Promise.all(
      _items.map(async (item) => {
        if (!item?.src) return undefined;
        const imageSource = await item?.src;
        // if (props.vod) {
        // const blob = await request({ method: 'GET', url: item?.src, responseType: 'blob' });
        // imageSource = URL.createObjectURL(blob);
        // return { ...item, src: imageSource };
        // await imageSource
        // }
        return { ...item, src: imageSource };
      })
    ).then(setItems);
  }, [props.timestamp, props.chanId, props.endTime, props.visible, props.vod, props.firstEpgStart]);

  const renderThumbnail = useCallback((src?: string, primary?: boolean, key?: string) => {
    return (
      <div
        className={getClassName('fast-seek-thumbnail-wrapper', { primary })}
        key={key}
        data-primary={primary}
      >
        {src && <Image src={src} fallbackSrc={DefaultThumbnail} />}
      </div>
    );
  }, []);
  return (
    <div
      className={getClassName('fast-seek-container', { visible: props.visible })}
      data-test-id="fast-seek-thumbnails"
    >
      {items.map((item, index) =>
        renderThumbnail(item?.src, item?.primary, `FAST-SEEK-THUMB-${index}`)
      )}
    </div>
  );
}
